var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"usWrap"},[_c('div',{staticClass:"usCont"},[_vm._m(0),_c('div',{staticClass:"content btmBrief",domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headTitle"},[_c('div',{staticClass:"title_img"}),_c('p',[_vm._v("关于我们")]),_c('div',{staticClass:"title_img"})])
}]

export { render, staticRenderFns }